import React, { useRef } from 'react';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { useRem2Px } from 'hooks';
import './index.less';

const MySwiper = ({ data, children }) => {
  const spaceBetween = useRem2Px(0.73);
  const swiperRef = useRef<SwiperRef>(null);

  return (
    <div className="my-swiper">
      <div className="my-swiper-nav my-swiper-nav_prev" onClick={() => swiperRef.current?.swiper.slidePrev()} />
      <Swiper
        ref={swiperRef}
        className="my-swiper-wrapper"
        modules={[Navigation, Autoplay]}
        spaceBetween={spaceBetween}
        slidesPerView={2}
        loop
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        navigation
      >
        {data.map((el, index) => {
          return <SwiperSlide key={index}>{children(el, index)}</SwiperSlide>;
        })}
      </Swiper>
      <div className="my-swiper-nav my-swiper-nav_next" onClick={() => swiperRef.current?.swiper.slideNext()} />
    </div>
  );
};

export default MySwiper;
